import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        formDisable: false,
        form: {
            model: {
                id: null,
                code: null,
                name: null,
                status: false,
                description: null,
            }
        }
    },
    getters: {
        ['RoleFormGetFormModel'](state) {
            return state.form.model
        },
    },
    mutations: {
        ['RoleFormSetLoading'](state, loading) {
            state.loading = loading
        },
        ['RoleFormSetFormModel'](state, model) {
            state.form.model = model
        },
        ['RoleFormSetFormDisable'](state, disable) {
            state.formDisable = disable;
        },
        ['RoleFormSetFormModelToNull'](state) {
            state.form.model = {
                id: null,
                code: null,
                name: null,
                status: false,
                description: null,
            }
        },
    },
    actions: {
        async addForm({commit}, model) {
            commit('RoleFormSetLoading', true);
            try {
                let result = await OrganizationServer.role.add(model);
                commit('RoleFormSetLoading', false);
                if (result.data.code === '200') {
                    return result.data.data.id;
                } else {
                    return null;
                }
            } catch (e) {
                commit('RoleFormSetLoading', false);
                throw e;
            }
        },
        async updateForm({commit}, model) {
            commit('RoleFormSetLoading', true);
            try {
                let result = await OrganizationServer.role.update(model.id, model);
                commit('RoleFormSetLoading', false);
                if (result.data.code === '200') {
                    return {
                        code: 200,
                        id: result.data.data.id,
                    }
                } else {
                    return {
                        code: 500,
                        message: result.data.message,
                    }
                }
            } catch (e) {
                commit('RoleFormSetLoading', false);
                throw e;
            }
        },
        async queryFormModel({commit}, id) {
            commit('RoleFormSetLoading', true);
            try {
                let result = await OrganizationServer.role.get(id);
                if (result.data.code === '200') {
                    commit('RoleFormSetFormModel', result.data.data);
                }
            } catch (e) {
                throw e;
            } finally {
                commit('RoleFormSetLoading', false);
            }
        }
    }

}